<template>
    <div class="row wrapper border-bottom white-bg page-heading">
        <div class="col-lg-10">
            <h2> {{ $t("navigations.fill form") }}</h2>
        </div>
        <div class="col-lg-2">
            <i class="fa fa-times close my-0" @click="onclosed()"></i>
        </div>
    </div>
    <div class="wrapper wrapper-content px-0">
        <div class="ibox-content">
          <dynamicform
  :templateid="templateId"
  :stdyid="stdyid"
  :visitids="visitids"
  :issavefun="saveactive"
  :isPatientVisit="ispatientvalue"
  :scheduledvisit="localScheduledVisit"
  :requirednewform="true"
  :key="localScheduledVisit"
/>

        </div>
    </div>
</template>

<script src="./formComponent.js"></script>